import React from "react";
 
const CSimpleLoader = () => {
  return (
    <div className="p-4 pb-2">
      <div className="dot-pulse"></div>
    </div>
  );
};
 
export default CSimpleLoader;